var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-button",
            {
              staticClass: "mb20",
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleAdd()
                },
              },
            },
            [_vm._v("添加退货规则")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "退货类型",
                  prop: "type",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("filterEmpty")(
                                _vm.typeToNameMap[scope.row.type]
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "退货规则", "show-overflow-tooltip": true },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterEmpty")(scope.row.typeName))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开始时间",
                  prop: "startTime",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterEmpty")(scope.row.startTime))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "结束时间",
                  prop: "endTime",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterEmpty")(scope.row.endTime))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleAdd(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm.checkPermi(["merchant:cdkey:library:delete"]) &&
                        !scope.row.productAttrValueName &&
                        !scope.row.productName
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.formValidate.id === 0 ? "新增退货规则" : "编辑退货规则",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "105px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "退货类型:", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择限购规则",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.formValidate.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "type", $$v)
                        },
                        expression: "formValidate.type",
                      },
                    },
                    _vm._l(_vm.returnArr, function (item, index) {
                      return _c("el-option", {
                        key: index.code,
                        attrs: { value: item.code, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退货规则名称:", prop: "typeName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入退货规则名称",
                      maxlength: "32",
                      type: "datetime",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formValidate.typeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "typeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.typeName",
                    },
                  }),
                ],
                1
              ),
              _vm.formValidate.type != 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "开始时间:", prop: "startTime" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form_content_width",
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                          type: "datetime",
                          placement: "bottom-start",
                          placeholder: "自定义时间",
                        },
                        model: {
                          value: _vm.formValidate.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "startTime", $$v)
                          },
                          expression: "formValidate.startTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.type != 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "结束时间:", prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form_content_width",
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                        },
                        model: {
                          value: _vm.formValidate.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "endTime", $$v)
                          },
                          expression: "formValidate.endTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.type == 3
                ? _c(
                    "el-form-item",
                    { attrs: { label: "扣费比例:", prop: "factor" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入扣费比例",
                          maxlength: "32",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formValidate.factor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate,
                              "factor",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formValidate.factor",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm.checkPermi(["merchant:product:update"])
                ? _c(
                    "el-button",
                    {
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }